import { ToneDto } from '../tonedto';

export interface CountSearchDetailsDto
{
    getAlbumDetailList(): ToneDto[];
    getArtistDetailList(): ToneDto[];
}

export class CountSearchDetailsDtoImpl implements CountSearchDetailsDto
{
    private albumDetailList: ToneDto[];
    private artistDetailList: ToneDto[];

    getAlbumDetailList(): ToneDto[]
    {
        return this.albumDetailList;
    }
    setAlbumDetailList(albumDetailList: ToneDto[])
    {
        this.albumDetailList = albumDetailList;
    }

    getArtistDetailList(): ToneDto[]
    {
        return this.artistDetailList;
    }
    setArtistDetailList(artistDetailList: ToneDto[])
    {
        this.artistDetailList = artistDetailList;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/specificsearchtone/countsearchdetails.ts